import { Drawer } from '@optiro/ui';

import { useIntervalDrawerAdapter } from './IntervalDrawer.adapter';
import { IntervalDrawerContentView } from './IntervalDrawer.view';
import { useIntervalDrawerContext } from './IntervalDrawerContext';

export function IntervalDrawer() {
  const { state, close } = useIntervalDrawerContext();

  return (
    <Drawer opened={!!state} onClose={close} title="Rediger booking" position="right" size="md">
      {state && <IntervalDrawerContent interval={state.interval} taskId={state.taskId} />}
    </Drawer>
  );
}

function IntervalDrawerContent({
  interval,
  taskId,
}: {
  interval: Parameters<typeof useIntervalDrawerAdapter>[0];
  taskId?: Parameters<typeof useIntervalDrawerAdapter>[1];
}) {
  const adapter = useIntervalDrawerAdapter(interval, taskId);

  return <IntervalDrawerContentView interval={interval} {...adapter} />;
}
